import styled from 'styled-components'

export const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
`

export const ModalWindow = styled.div`
  box-sizing: border-box;
  max-height: 95vh;
  max-width: 95vw;
  width: 1150px;
  height: 910px;
  background: #ffffff;
  border-radius: 10px;
  padding: 36px 55px 30px;
  position: relative;
  overflow-y: auto;

  @media (max-width: 500px) {
    max-height: min(90vh, 900px);
    width: 100%;
    max-width: 100%;
    align-self: flex-end;
    padding-bottom: 10vh;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    padding: 20px 10px;
  }
`

export const CloseButton = styled.button`
  position: absolute;
  top: 30px;
  right: 30px;
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  cursor: pointer;

  & img {
    width: 20px;
  }

  @media (max-width: 500px) {
    top: 15px;
    right: 15px;
  }
`

export const Title = styled.span`
  font-family: Helvetica Neue;
  font-size: 24px;
  font-weight: 700;
  line-height: 29px;
  letter-spacing: 0.01em;
  text-align: center;
  display: block;
  margin: 0 auto 30px;

  @media (max-width: 500px) {
    font-size: 18px;
    margin-bottom: 20px;
  }
`

export const Grid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-auto-rows: 1fr;
  grid-gap: 16px;

  @media (max-width: 500px) {
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
  }
`

export const Card = styled.button`
  border: 0;
  aspect-ratio: 1;
  padding: 0;
  border-radius: 16px;
  line-height: 0;
  overflow: hidden;
  cursor: pointer;
  position: relative;
  @media (max-width: 500px) {
    border-radius: 10px;
  }

  &:after {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    border: ${({ isSelected }) => (isSelected ? '4px solid #FF5E6D' : 0)};
    border-radius: 16px;

    @media (max-width: 500px) {
      border: ${({ isSelected }) => (isSelected ? '2px solid #FF5E6D' : 0)};
      border-radius: 10px;
    }
  }

  & img {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
  }

  & svg {
    position: absolute;
    top: 15px;
    right: 15px;
    @media (max-width: 500px) {
      top: 10px;
      right: 10px;
    }
  }
`

export const Submit = styled.button`
  height: 42px;
  width: 400px;
  border-radius: 37px;
  border: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ff5e6d;
  font-family: Helvetica Neue;
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  text-align: center;
  color: #fff;
  position: sticky;
  bottom: 20px;
  left: 50%;
  transform: translate(-50%);
  cursor: pointer;
  @media (max-width: 500px) {
    height: 40px;
    max-width: 90%;
    width: 300px;
    border-radius: 37px;
    font-size: 14px;
    position: fixed;
    bottom: 50px;
  }
`
